import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Spin, Table, Input ,Select} from 'antd';
import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { SearchOutlined, RedoOutlined } from '@ant-design/icons';
import { ContextHandler } from '../../public/js/contextHandler';
import trans from './translation';
import PropTypes from 'prop-types';//props传参检查库
import Message from '../message/message';
import context from '../../public/js/context';
const { Option } = Select;
const SelectProgModal = (props) => {

    const messageRef = useRef();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0); //总条数
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({"activeInd":"Y"});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [deptList, setDeptList] = useState([]);

    const tableColumns = {
        progCode: "prog_code",
        progLaunchYear: "prog_launch_year",
    }

    useEffect(() => {
        searchAllDept();
        search(pageSize, 1, "N");
        if (props.progModel?.progId) {
            setSelectedRowKeys([props.progModel.progId]);
            setCheckboxState([props.progModel]);
        }
    }, []);

    //查询
    const searchAllDept = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("commonDropDown/searchAllDept").then((data) => {
            if ("SUCCESS" === data.msg) {
                setDeptList(data.object ?? [])
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }


    //查询
    const search = (pageSizeNew, current, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        setIsLoad(true);
        Base.callBackApi("commonDropDown/searchProgramme", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const save = () => {
        if (selectedRowKeys.length !== 1) {
            errFrameShow("error", trans.selectiveData[Config.backLang]);
            return;
        }
        props.onClose(true, checkboxState[0]);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style);
        messageRef.current.setContent(msg);
        messageRef.current.setIsShow(true);
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
        type: 'radio',
    }

    const columns = [
        {
            title: "Programme Code",
            dataIndex: 'progCode',
            className: 'tableWidth30',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progCode') },
        },
        {
            title: "Programme Name",
            dataIndex: 'progTitle',
            className: 'tableWidth30',
        },
        // {
        //     title: "Launch Year",
        //     dataIndex: 'progLaunchYear',
        //     className: 'tableWidth15',
        //     sorter: (a, b) => { return Base.sortMethod(a, b, 'progLaunchYear') },
        // },
        {
            title: "Department",
            dataIndex: 'department',
            className: 'tableWidth30',
            render: (text, record) => record.deptCode + '-' + record.deptDisplayName
        },
        {
            title: "Status",
            dataIndex: 'activeInd',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValueTransalation('activeTransalation', text)
        },
    ];
    return (
        <Modal
            visible={true}
            title="Select Programme"//标题
            centered//垂直居中
            closable//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭    
            width={'1052px'}
            onCancel={() => props.onClose(false)}
            footer={[
                <Button key='save' className='sysBtn btnBlue' type="primary" onClick={save} icon={<CheckCircleOutlined />}>{trans.select[Config.backLang]}</Button>,
                <Button key='cancel' className="sysBtn" onClick={() => props.onClose(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
            ]}
        >
            <Spin size="large" spinning={isLoad} tip={trans.beQuerying[Config.backLang]}>
                <Message ref={messageRef} />
                <div className='sysSearchRow'>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysTitles">Programme Code</div>
                            <div className="sysSerchInput">
                                <Input type="text" placeholder="Programme Code"
                                    onChange={(e) => searchChange('progCode', e.target.value)}
                                    value={searchModel.progCode || ''} />
                            </div>
                        </div><div className='sysCol'>
                            <div className="sysTitles">Programme Name</div>
                            <div className="sysSerchInput">
                                <Input type="text" placeholder="Programme Name"
                                    onChange={(e) => searchChange('progTitle', e.target.value)}
                                    value={searchModel.progTitle || ''} />
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitles">Department</div>
                            <div className="sysSerchInput">
                                <Select className="sysSelect" placeholder="Department"
                                    value={searchModel.deptId || ''}
                                    onChange={(e) => searchChange('deptId', e)}
                                >
                                    <Option value=""></Option>
                                    {deptList.map((item) => <Option key={item.deptId} value={item.deptId}>{item.deptCode + '-' + item.deptDisplayName}</Option>)}
                                </Select>
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitles">Status</div>
                            <div className="sysSerchInput">
                                <Select className="sysSelect" placeholder="Status"
                                    value={searchModel.activeInd || ''}
                                    onChange={(e) => searchChange('activeInd', e)}
                                >
                                    <Option value=""></Option>
                                    {context.activeTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                </Select>
                            </div>
                        </div>
                        <div className='sysSearchButton'>
                            <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                        </div>
                    </div>
                </div>
                <div className="sysLineEight"></div>
                <div className="sysTable" id="tableOne">
                    <Table
                        rowSelection={rowSelection}
                        scroll={{ x: 800 }}
                        rowKey="progId" //Key值
                        columns={columns} //列名
                        dataSource={tables} //数据
                        pagination={{  //分页
                            showSizeChanger: true,    //是否显示可以设置几条一页的选项
                            onChange: onChange,       //上页下页或者跳页方法
                            onShowSizeChange: onShowSizeChange, //每页显示条数方法
                            total: tablesCount,        //总共多少条数据
                            current: current,       //当前页
                            pageSize: pageSize,  //每页显示多少条数据
                            defaultCurrent: 1, //默认当前页为1
                            size: "small"
                        }}
                        onRow={(record) => {
                            return {
                                onClick: event => Base.selectRadioRowNew.call(this, record, 'progId', selectedRowKeys, setCheckboxState, setSelectedRowKeys),
                            };
                        }}
                        onChange={handleTableChange}
                    />
                </div>
            </Spin>
        </Modal>
    )

}

SelectProgModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    progModel: PropTypes.any
}

export default SelectProgModal;